import styled from 'styled-components';
import { getDashboardComponentTop, getDashboardComponentHeight, getDashboardComponentLeft, getDashboardComponentWidth, } from '../../Dashboard.utils';
export const Root = styled.div `
    position: absolute;
    z-index: 1;
    top: ${(props) => getDashboardComponentTop(props.top, props.rowHeight, props.gutter)}px;
    height: ${(props) => getDashboardComponentHeight(props.height, props.rowHeight, props.gutter)}px;
    left: ${(props) => getDashboardComponentLeft(props.left, props.columnCount, props.gutter)};
    width: ${(props) => getDashboardComponentWidth(props.width, props.columnCount, props.gutter)};
    transition: top 0.1s ease-in, left 0.1s ease-in;
`;
export const ComponentPlaceholder = styled.div `
    background-color: white;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    padding: 16px;
    height: 100%;
`;
export const DeleteButton = styled.div `
    position: absolute;
    z-index: 2;
    top: 4px;
    right: 4px;
`;
//# sourceMappingURL=DashboardEditComponent.styled.js.map